module.exports = __webpack_public_path__ + "static/media/mfg.1f120de1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/mfg.svg
// module id = 340
// module chunks = 0